import React from "react";
import Section from "../../components/Section";
import Project from "../../components/Cards/Project";
import projectsData from "../../data/projects.json";

/**
 * Projects section component that displays all projects from JSON data.
 * Each project is rendered using the Project card component.
 */
function Projects() {
  return (
    <Section id="projects" title="Projects">
      {projectsData.map((project, index) => (
        <Project
          key={index}
          date={project.date}
          title={project.title}
          url={project.url}
          type={project.type}
          problem={project.problem}
          solution={project.solution}
          management={project.management}
          impact={project.impact}
          contribution={project.contribution}
          tags={project.tags}
        />
      ))}
    </Section>
  );
}

export default Projects;
